import Vue from 'vue'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VSelect from '../components/editor/components/VSelect'

Vue.component('VueSelect', VueSelect)
Vue.component('VSelect', VSelect)
